package org.hs_soft.runmynesto.domain.config

import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

object Dimen
{
    val draggedFilterBorderRadius=100.px
    val priceContentCheckoutHeight=176.px
    val priceTableHeight=200.px
    val priceTableWidth=810.px
    val ArticlesRowColumnWidth=220.px
    val draggedFilterInputWidth=400.px
    val ArticlesRowColumnHeight=344.px
    val errorDialogWidth=320.px
    val errorDialogMaxWidth=400.px
    val errorDialogHeight=72.px
    val dashboardReportItemInfoInnerHeight=38.px
    val deviceItemWidth=318.px
    val storeItemWidth=334.px
    val artHeight=228.px
    val restaurantDesignMinHeight=1000.px
    val leftZoomMargin=1294.px
    val tableOptionWidth=112.px
    val tableOptionHeight=138.px
    val createCustomAlergeneDialogWidth=348.px
    val createCustomAlergeneDialogHeight=394.px
    val restaurantParentIconSize=100.px
    val mediumRadioInputHeight=16.px
    val restaurantOptionHeight=48.px
    val forgetPassSendCodeHeight=452.px
    val resetPasswordHeight=704.px
    val rmr_icon=100.px
    val loginLayoutWidth=396.px
    val loginLayoutHeight=550.px
    val apaleoConfigurationTableWidth=400.px
    val promptImageAIDialogWidth=256.px
    val promptImageAIDialogHeight=206.px
    val uploadImgSize=256.px
    val showDefaultUploadImgSize=190.px
    val saleGroupTableHeight=300.px
    val dialogTitleHeight=64.px
    val checkBoxParentSize=34.px
    val radioButtonParentSize=34.px
    val checkBoxSize=20.px
    val designCoordinateMinHeight=600.px
    val mobileWaiterListTypeTitleWidth=200.px
    val chartMobileHeight=386.px
    val chartTabletHeight=402.px
    val chartWindowsHeight=720.px
    val allergensNameWidth=140.px
    val tableMinHeight=100.px
    val abcTableMinHeight=300.px
    val maxWidth = 1200.px
    val billSearchFilterWidth=376.px
    val templateContentGeneralInfoWidth=572.px
    val dashboardChartHeight=880.px
    val dashboardReportsHeight=864.px
    val outlineBoxInnerHeight=32.px
    val cashRegisterTypeTitleWidth=280.px
    val addNewDeviceToCashRegistersDialogHeight=650.px
    val addNewDeviceToCashRegistersDialogWidth=580.px
    val addNewDeviceToCashRegistersDialogMobileWidth=370.px
    val restaurantProjectWidth=400.px
    val reportsTableSalesVolumeWidth=90.px
    val reportsTableDeviceWidth=170.px
    val reportsTableNumberWidth=60.px
    val reportsTableTimeWidth=80.px
    val reportsTableDateWidth= 100.px
    val dateFilterWidth=120.px
    val desktopWaiterListTypeTitleHeight=50.px
    val desktopWaiterListTypeLabelWidth=51.px
    val desktopWaiterListTypeLabelHeight=32.px
    val desktopWaiterListTypeImgHeight=100.px
    val mobileWaiterTilesTypeItemSize=110.px
    val desktopWaiterTilesTypeItemHeight=150.px
    val desktopWaiterTilesTypeItemWidth=158.px
    val mobileWaiterListTypeItemHeight=60.px
    val mobileWaiterListTypeItemWidth=350.px
    val TemplateArticleListHeight=571.px
    val dashboardItemPercentageBorder=100.px
    val dashboardItemPercentageWidth=59.px
    val dashboardItemPercentageHeight=18.px

    val dashboardItemGeneralInfoHeight=88.px
    val previewPdfWidth=600.px
    val previewPdfHeight=800.px
    val previewPdfMobileWidth=350.px
    val previewPdfMobileHeight=600.px
    val applicationsDialogMarginRightInTablet=50.px
    val applicationsDialogPhoneHeight=224.px
    val applicationsDialogWidth=408.px
    val applicationsDialogHeight=240.px

    val menuTooltipHeight=22.px
    val dataAssistantButtonSize = 60
    val dataAssistantWelcomeWidth = 80.px
    val dataAssistantWelcomeHeight= 89.px
    val dataAssistantAIDialogWidth=400.px
    val dataAssistantAIDialogHeight=560.px
    val warningBannerHeight=63.px


    val radioButtonRowHeight=34.px
    val filterGridDialogHeight=260.px
    val menuItemInfoWidth=244.px
    val menuItemParentSize=34.px
    val filterWidth=91.px
    val filterHeight=34.px
    val closingReportsPhoneWidth=1000.px
    val loadingSize=60.px
    val wallBigSide=70.px
    val wallSmallSide=10.px
    val restaurantDecorSize=60.px
    val restaurantDecorImgSize=52.px
    val AddGroupDialogItemsHeight=300.px
    val menuItemHeight=24.px
    val billSearchPhoneTabletWidth=1200.px
    val filterABCStatisticHeight=224.px
    val CompareChartDayItemWidth=320.px
    val smallCircle=14.px
    val extraSmallCircle=10.px
    val dashboardReportItemInfoWidth=172.px
    val dashboardReportItemInfoHeight=54.px
    val dashboardReportItemHeaderHeight=55.px
    val dashboardReportItemHeight=547.px
    val dashboardReportItemMobileHeight=356.px
    val dashboardReportItemWidth=300.px
    val dashboardReportItemTabletPhoneWidth=348.px
    val closingReportsTabletModeHeight=800.px
    val daysFilterContentHeight=224.px
    val daysFilterDialogHeight=357.px
    val daysFilterDialogWidth=300.px
    val closingDailyReportDialogWidth=350.px
    val closingReportsTableHeight=320.px
    val selectedBillSearchTableHeight=353.px
    val billSearchTableHeight=400.px
    val closingReportTable3Height=164.px
    val closingReportTable1Height=216.px
    val abcStatisticTableHeight=264.px
    val apaleoSalesGroupTableHeight=300.px
    val transactionColumnItemPhoneWidth=140.px
    val transactionColumnItemWidth=200.px
    val selectTransactionDialogWidth=650.px
    val selectTransactionDialogHeight=400.px
    val selectTransactionDialogPhoneHeight=400.px
    val selectTransactionDialogPhoneWidth=320.px
    val addNewCustomerWidth=360.px
    val periodMonthWidth=167.px
    val tabletTabsWidth=(window.innerWidth*0.55).px
    val tabletTabsSmallWidth=(window.innerWidth*0.4).px
    val printLocationNameWidth=180.px
    val companyItemWidth=120.px
    val companyItemHeight=100.px
    val companyImgWidth=50.px
    val companyImgHeight=30.px
    val mobileTabsWidth= (window.innerWidth*0.9).px
    val chartWidth=(window.innerWidth*0.9)
    val tabItemWidth=130.px
    val walletCardParentHeight=500.px
    const val barcodeSize=120
    const val googleWalletPickImgHeight=100
    const val galleryRectSmallHeight=35
    const val galleryRectSmallWidth=107
    val walletCardWidth=300.px
    val walletCardHeight=440.px
    val minimumContentTitleHeight=32.px
    val semiNormalTextAreaHeight=73.px
    val normalTextAreaHeight=97.px
    val mediumTextAreaHeight = 100.px
    val largeTextAreaHeight=290.px
    val kitchenInfoTitleHeight = 25.px
    val kitchenAddItemDialogWidth=666.px
    val kitchenAddItemDialogHeight=560.px
    val walletDialogHeight=600.px
    val walletDialogWidth=650.px
    val mediumRadioButton=24.px
    val imageAIDialogWidth=584.px
    val imageAIDialogHeight=514.px
    val verticalDialogWidth=350.px
    val verticalAIDialogHeight=580.px
    val menuCardAIFilesUploadHeight=360.px
    val rectColor = 24.px
    val datePickerWidth=282.px
    val datePickerHeight=346.px
    val allergensTableWidth=530.px
    val allergensHeaderItemWidth=160.px
    val checkOutSmallLineWidth=8.px
    val checkOutNormalLineWidth=6.px
    val mediumTextAreaWidth=300.px
    val userTabHeight= 34.px

    val smallBlurRadius=1.px
    val normalBlurRadius=2.px
    val mediumBlurRadius=3.px
    val smallSpreadRadius=1.px
    val normalSpreadRadius=2.px
    val mediumSpreadRadius=3.px

    val addRecordDialogWidth=464.px
    val addRecordDialogPhoneWidth=348.px
    val addRecordDialogHeight=286.px
    val addRecordDialogOneFieldHeight=200.px
    val articleListWidth=750.px
    val selectCirclePhotoSize=145.px
    val selectRectPhoneWidth=300.px
    val selectRectPhoneHeight=170.px
    val circleItemProgressSize=6.px
    val gridHeaderNumberWidth=90.px
    val gridCustomerCardNumberWidth=45.px
    val headerSmallWidth=85.px
    val headerMediumWidth=125.px
    val headerLargeWidth=145.px
    val headerExtraLargeWidth=165.px
    val kitchenInfoItemsHeight=140.px
    val gridWidth = 320.px
    val gridCustomerCardWidth=350.px
    val gridItemHeight=32.px
    val gridHeaderHeight=36.px
    val gridItemMinHeight=32.px
    val mediumGridFooterHeight=46.px
    val normalGridFooterHeight=32.px
    val labelHeight=10.px
    val DateItemSize = 34.px
    val DateDaysWidth= (7* DateItemSize.value.toInt()).px
    val mediumTableItemHeight=32.px
    val addOrEditFixedProductWidth=368.px
    val extraLargeEditTextWidth=427.px
    val semiExtraLargeEditTextWidth=360.px
    val largeEditTextWidth2=342.px
    val largeEditTextWidth=330.px
    val semiLargeEditTextWidth=300.px
    val mediumEditTextWidth=250.px
    val extraSemiMediumEditText=220.px
    val semiMediumEditTextWidth=200.px
    val highNormalEditTextWidth=170.px
    val normalEditTextWidth2=150.px
    val normalEditTextWidth=140.px
    val semiNormalEditTextWidth=120.px
    val semiSmallEditTextWidth=100.px
    val smallEditTextWidth=80.px
    val extraSmallEditTextWidth=72.px

    val loginDialogCorner=16.px
    val loginDialogWidth=550.px
    val loginDialogHeight=450.px
    val loginSubmitHeight=46.px
    val loginInputWidth=300.px
    val fieldErrorMsgHeight=10.px

    val dropDownHeight=40.px
    val mediumOutlinedEditTextHeight=34.px
    val outlinedEditTextParentHeight=42.px
    val topToolbarHeight=56.px
    val normalOutlinedEditTextHeight=36.px
    val checkOutItemHeight=36.px
    val checkOutItemWidth=350.px
    val itemSeparatorHeight=20.px
    const val activePageSelectorWidth=15
    const val activePageSelectorHeight=21
    const val inactivePageSelectorWidth=3
    const val inactivePageSelectorHeight=18

    val submitButtonHeight=34.px
    val mediumSubmitButtonWidth=150.px
    val semiLargeSubmitButtonWidth=163.px
    val generateButtonWidth=170.px
    val restaurantInfoAddWidth=220.px
    val submitButtonPhoneWidth=110.px

    val menuDefaultWidth=57.px
    val paddingOfApplicationDialog=54.px
    val restaurantItemLineHeight=7.px

    //Padding
    val extraExtraSmallPadding = 1.px
    val extraSmallPadding = 2.px
    val semiSmallPadding=3.px
    val smallPadding=4.px
    val semiSemiNormalPadding=5.px
    val semiNormalPadding=6.px
    val normalPadding=8.px
    val semiMediumPadding=10.px
    val mediumPadding=12.px
    val semiLargePadding=14.px
    val largePadding=16.px
    val highLargePadding=20.px
    val semiExtraLargePadding=22.px
    val extraLargePadding=24.px
    val extraLargePadding2=32.px
    val extraExtraLargePadding=40.px
    val semiExtraExtraLargePadding=42.px
    val semiExtraExtraLargePadding2=48.px
    val veryExtraExtraPadding=56.px


    //Border
    val smallBorderRadius=2.px
    val semiSmallBorderRadius=4.px
    val lowBorderRadius=5.px
    val mediumBorderRadius=8.px
    val semiLargeRadius=10.px
    val largeBorderRadius=12.px
    val semiExtraLargeBorderRadius=16.6.px
    val extraLargeBorderRadius=18.px

    val extraSmallThickness=0.5.px
    val smallThickness=1.px
    val semiSmallThickness=1.5.px
    val mediumThickness=2.px
    val largeThickness=3.px
    val extraLargeThickness=4.px

    //-Menu-------------------------------------
    val menuItemsHeight=500.px
    val menuItemRowWidthDesktopAndTablet=300.px
    val menuItemRowWidthPhone=240.px
    val menuItemRowWidth = 280.px
    val menuItemRowHeight=44.px
    const val subMenuItemRowHeight=36
    val menuFooterHeight=142.px
    val footerInfoHeight=70.px
    //Offset------------------------------------
    val smallOffsetX=1.px
    val smallOffsetY=1.px
    //Alpha-------------------------------------
    val semiSmallAlpha=0.15f
    //Icon Sizes----------------
    const val extraSmallIcon=14
    const val smallIconSize=16
    const val semiNormalIconSize=18
    const val normalIconSize=20
    const val semiMediumIconSize=22
    const val mediumIconSize=24
    const val highMediumIconSize=30
    const val semiLargeIconSize=32
    const val semiLargeIconSize2=34
    const val largeIconSize=36
    const val extraLargeIconSize=40
    val extraExtraLargeIconSize = 48.px





}